import { updateCalendarAvailability } from "./updateCalendarAvailability";
import { updateRecommendations } from "./updateRecommendations";

export function updateSelectedServices() {
  console.log('update selected services')
  let serviceInput = document.querySelector('[name="services"]');
  let services = serviceInput.value;
  const url = location.protocol + '//' + location.host;
  const route = `/update_selected_services/${encodeURIComponent(services)}`;
  const fullUrl = url.concat(route);
  const xhr = new XMLHttpRequest()
  xhr.open("GET", route)
  xhr.setRequestHeader("Content-Type", "application/javascript");
  xhr.send()
  xhr.onload = function () {
    let summaryContainers = document.querySelectorAll('.appointment-summaryContainer');
    summaryContainers.forEach((c) => {
      c.innerHTML = xhr.responseText
    })
    addCloseServiceEvent();
    updateCalendarAvailability();
  }
}

function addCloseServiceEvent() {
  let closeButtons = document.querySelectorAll('.service-closeButton');
  closeButtons.forEach((c) => {
    c.addEventListener('click', (e) => {
      removeServiceFromForm(e.target.dataset.serviceName)
    })
  })
}

function removeServiceFromForm(service) {
  let serviceInput = document.querySelector('[name="services"]');
  let services = serviceInput.value.split(', ')
  serviceInput.value = services.filter((s) => { return s !== service }).join(', ')
  updateSelectedServices();
  updateRecommendations();
}
